/* src/app/shared/components/pull-to-refresh/pull-to-refresh.scss */
.ion-col-with-left-and-right-icon {
  display: flex;
  justify-content: center;
}
.ion-col-with-left-and-right-icon ion-text {
  padding-left: 1%;
  padding-right: 1%;
  align-self: center;
}
/*# sourceMappingURL=pull-to-refresh.css.map */
